<template lang="">
  <div class="row">
    <div class="col-lg-4 lbv-notes">
      <b-card header="New note">
        <div class="form-row">
          <b-form-textarea
            id="newMesage"
            v-model="message"
            :rows="6"
            :max-rows="10"
          />
        </div>
        <div class="form-row action">
          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="addNote"
          >
            Create Note
          </button>
        </div>
      </b-card>
    </div>
    <div class="col-lg-8 lbv-notes">
      <b-card header="Notes">
        <b-list-group
          flush
          class="scrollable"
        >
          <b-list-group-item
            v-for="(note, index) in notes"
            :key="index"
          >
            <small class="note-meta"><span class="note-date-time">{{ note.updated }}</span> - <span class="note-authour">{{ note.username }}</span></small>
            <div class="note-body">
              {{ note.notes | decodeFromBase64 }}
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
  </div>
</template>

<script>
import { APIEvent } from '../../events/apiEvent'
import { TabNavEvent } from '../../events/tabNavEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { EventBus } from '../../event-bus'
import { B64ToUTF8, UTF8ToB64 } from '../../utils'

export default {
  name: 'ContactNotes',
  filters: {
    decodeFromBase64 (value) {
      try {
        return B64ToUTF8(value)
      } catch (e) {
        return value
      }
    }
  },
  props: ['lb_id'],
  data () {
    return {
      notes: [],
      message: ''
    }
  },
  mounted () {
    EventBus.$on(TabNavEvent.CONTACT_NOTES, () => { this.fetchNotes() })
  },
  destroyed () {
    EventBus.$off(TabNavEvent.CONTACT_NOTES)
  },
  methods: {
    fetchNotes: function () {
      if (this.lb_id) {
        this.$store.dispatch(APIEvent.FETCH_NOTES, this.lb_id)
          .then((response) => {
            this.notes = response.data.list.record
            document.getElementsByClassName('scrollable')[0].scrollTop = 0
            this.message = ''
          })
          .catch(this.handleError)
      }
    },
    addNote: function () {
      if (this.message.trim() !== '') {
        var newNote = {}
        newNote.LbDevice_ID = this.lb_id
        newNote.action = '1'
        newNote.notes = UTF8ToB64(this.message)
        this.$store.dispatch(APIEvent.ADD_NOTE, newNote)
          .then((response) => {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Note successfully added.')
            this.fetchNotes()
          })
          .catch(this.handleError)
      } else {
        EventBus.$emit(StatusBarEvent.WARNING,
          'Please enter a note before clicking on Create Note.')
      }
    },
    handleError: function (error) {
      var errorMsg = 'Your changes could not be saved. Please check and try again :: '
      EventBus.$emit(StatusBarEvent.ERROR, errorMsg + error.message)
    }
  }
}
</script>

<style scoped lang="css">
  .scrollable {
    max-height: 320px;
    overflow-y: scroll;
  }
</style>
